import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SUBAWARDEE_INFO } from '../config/initiativeLeadsMapping';

export function isKnownSubawardee(id: string | null): id is string {
  return id != null && SUBAWARDEE_INFO.some((s) => s.id === id);
}

interface AdminSubawardeeFilterStore {
  subawardee: string | null;
  setSubawardee: (value: string | null) => void;
}

export const useAdminSubawardeeFilterStore = create<AdminSubawardeeFilterStore>()(
  persist(
    (set) => ({
      subawardee: null,
      setSubawardee: (value) => {
        if (value === null || isKnownSubawardee(value)) {
          set({ subawardee: value });
        }
      },
    }),
    { name: 'admin-subawardee-filter' }
  )
);
